module.exports = __webpack_public_path__ + "static/media/woman-vampire_1f9db-200d-2640-fe0f.dd6f8c1f.png";